import { clsx } from 'clsx';

import { OrderDetailCard } from '../order-detail-card';
import useStyles from './OrderProductsByCorridor.styles';
import { useOrderProductsByCorridor } from './useOrderProductsByCorridor';
import { useEffect } from 'react';

//TODO: the products by Corridor are disabled Q12025
export function OrderProductsByCorridor(props) {
  const { showAddValueButton = true, classes = {}, orderId } = props;

  const {
    sortedProducts,
    handleCheckDefectProduct,
    isDefectProductsChecked,
  } = useOrderProductsByCorridor({ orderId });

  const _classes = useStyles();

  return (
    <div className={clsx(classes?.root)}>
      {sortedProducts.map((product, index) => {
        return (
          <OrderDetailCard
            key={`p-${index}`}
            product={product}
            showAddValueButton={showAddValueButton}
            handleCheckDefectProduct={handleCheckDefectProduct}
            isDefectProductsChecked={isDefectProductsChecked}
          />
        );
      })}
    </div>
  );
}
